var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkIconBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7245 15.3851L10.7245 15.385L10.7138 15.3927L6.75267 18.2391C6.75161 18.2397 6.75073 18.2402 6.75003 18.2405C6.75001 18.2398 6.75 18.2389 6.75 18.238V5.75874C6.75 5.75521 6.75025 5.75232 6.75059 5.75H16.4087C16.4095 5.75112 16.4101 5.75225 16.4105 5.75327C16.411 5.75449 16.4115 5.75591 16.4115 5.75874V18.238C16.4115 18.2391 16.4115 18.2401 16.4114 18.241L12.4477 15.3927L12.4478 15.3926L12.4369 15.3851C11.9205 15.0276 11.241 15.0276 10.7245 15.3851Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIconBlack);
export default __webpack_public_path__ + "static/media/bookmark-icon-black.2038e5a6649668f3e19127bd17d2bc5d.svg";
export { ForwardRef as ReactComponent };